









































































































































































































































































































































































import { Vue, Component, Watch, Mixins } from "vue-property-decorator";
import moment from "moment";
import _ from "lodash";
import SubMenu from "@/components/SubMenu.vue";
import MyList from "@/mixins/list";

import { find } from "@/libs/utils";

import TsUpload from "@/components/upload.vue";

import Notification from "@/views/notification/index.vue";
import OperationLog from "@/views/operationlog.vue";

import UserDetail from "@/views/users/detail.vue";
import BillDetail from "@/views/bill/detail.vue";

import TsConfirm from "@/components/confirm.vue";

import LineChart from "@/views/statistics-analy/line-chart.vue";

import TemplateMessage from "@/views/templatemessage.vue";

@Component({
  components: {
    "sub-menu": SubMenu,
    TsUpload,
    TsConfirm,
    Notification,
    OperationLog,
    UserDetail,
    BillDetail,
    LineChart,
    TemplateMessage
  }
})
export default class extends Mixins(MyList) {
  isMounted = false;

  pwdForm!: any;

  infoForm!: any;

  collapsed = true;

  pwdModalVisible = false;

  infoModalVisible = false;

  templatemessageModalVisible = false;

  year: string = moment().format("YYYY");

  // 定义 menus 数组 ，中间有多个menu菜单项
  menus: any[] = [];

  menuSelectedKeys: any = [];

  subMenuSelectedKeys: any = [];

  subMenus: any[] = [];

  userInfo: { [t: string]: any } = {};

  oriStadiumData = "";

  oriMessageData = "";

  isPlaying = false;

  intervalId!: number;

  imageUrl = "";

  loading = false;

  notificationModalVisible = false;

  operationlogModalVisible = false;

  msgCategoryId = 0;

  menuLeft: any = {
    height: "calc(100vh - 64px)",
    marginLeft: "200px",
    overflowY: "auto"
  };

  @Watch("$route")
  watchRoute(val: any, oldval: any) {
    this.setCurrentPosition(val.path, "watch");
  }

  showNotificationModal(categoryId: number) {
    this.msgCategoryId = categoryId;
    this.notificationModalVisible = true;
  }

  hideNotificationModal() {
    this.notificationModalVisible = false;
  }

  showOperationLogModal() {
    this.operationlogModalVisible = true;
  }

  hideOperationLogModal() {
    this.operationlogModalVisible = false;
  }

  showTemplateMessageModal() {
    this.templatemessageModalVisible = true;
  }

  hideTemplateMessageModal() {
    this.templatemessageModalVisible = false;
  }

  beforeCreate() {
    this.pwdForm = this.$form.createForm(this);
    this.infoForm = this.$form.createForm(this);
  }

  get computedBg() {
    return this.$store.state.gSetBg;
  }

  get computedUnReadMsgNum() {
    return this.$store.state.unReadMsgNum;
  }

  get computedUnReadMsgList() {
    return this.$store.state.unReadMsgList;
  }

  get computedBreadcrumbs() {
    // console.log(this.$store.state.breadcrumbs)
    return this.$store.state.breadcrumbs;
  }

  get computedConfirmModalVisible() {
    return this.$store.state.gConfirmModalVisible;
  }

  get computedUserDetailModalVisible() {
    return this.$store.state.gUserDetailModalVisible;
  }

  get computedBillDetailModalVisible() {
    return this.$store.state.gBillDetailModalVisible;
  }

  get computedLineChartModalVisible() {
    return this.$store.state.gLineChartModalVisible;
  }

  get computedLineChartParams() {
    return this.$store.state.gLineChartParams;
  }

  get computedUserId() {
    return this.$store.state.gUserId;
  }

  get computedBillId() {
    return this.$store.state.gBillId;
  }

  get computedGPagination() {
    return this.$store.state.gPagination;
  }

  logout() {
    this.$confirm({
      title: "确认信息",
      content: "确认登出系统吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("user/logout", {});
        if (res && res.Message === "success") {
          this.$message.success(res.Message);

          window.location.href = "/";
        } else {
          this.$message.error(res.Message);
        }
        // window.localStorage.removeItem('token')
      }
    });
  }

  showPwdModal() {
    this.pwdModalVisible = true;
  }

  showInfoModal() {
    this.infoModalVisible = true;
  }

  handleSubmit(name: string) {
    if (name === "pwd") {
      this.pwdForm.validateFields((err: any, values: any) => {
        if (!err) {
          this.$confirm({
            title: "确认信息",
            content: "确定要提交吗？",
            onOk: async () => {
              const res = await this.$store.dispatch("user/changePwd", {
                ...values
              });
              if (res && res.Message && res.Message === "修改成功") {
                this.$message.success("修改密码成功");
                this.pwdModalVisible = false;
              } else {
                this.$message.error("修改密码失败");
              }
            }
          });
        }
      });
    } else if (name === "info") {
      this.infoForm.validateFields((err: any, values: any) => {
        if (!err) {
          this.$confirm({
            title: "确认信息",
            content: "确定要提交吗？",
            onOk: async () => {
              const res = await this.$store.dispatch("user/saveInfo", {
                ...values
              });
              if (res && res.Message && res.Message === "success") {
                this.$message.success(res.Message);
                this.userInfo.avatar = values.avatar;
                this.infoModalVisible = false;
              } else {
                this.$message.error(res.Message);
              }
            }
          });
        }
      });
    }
  }

  handleCancel1(name: string) {
    if (name === "pwd") {
      this.pwdModalVisible = false;
    } else {
      this.infoModalVisible = false;
    }
  }

  setCurrentPosition(path: string, type: string) {
    if (_.isEmpty(this.menus)) {
      return;
    }

    if (path === "/") {
      this.menuSelectedKeys = [];
      this.collapsed = true;
      this.menuLeft.marginLeft = 0;
      return;
    }

    this.menuLeft.marginLeft = "200px";

    this.collapsed = false;

    const patharr: string[] = path.split("/");
    if (patharr.length > 3) {
      path = path.substring(0, path.lastIndexOf("/"));
    }

    let arr: [] = find(this.menus, path);

    if (arr === undefined) {
      // 用上一步 的
      type = "mounted";
      const m: any = window.localStorage.getItem("menuSelectedKeys");
      this.menuSelectedKeys = [];
      // console.log(JSON.parse(m))
      this.menuSelectedKeys = [...JSON.parse(m)];
      // console.log(this.menuSelectedKeys)
      // return;
      // 不在管理后台配置的菜单中

      // console.log(patharr);
      // 大于
      if (patharr.length >= 3) {
        path = path.substr(0, path.lastIndexOf("/"));
        // console.log(path)
        arr = find(this.menus, path);
      }
    }

    // console.log(arr)
    if (arr === undefined) {
      return;
    }

    const arr1: any[] = [];

    arr1.push({
      breadcrumbName: "首页",
      path: "/"
    });

    if (path === "/") {
      return;
    }

    let arr3: any[] = [];

    if (type === "mounted") {
      arr3 = this.menuSelectedKeys;
    }

    for (let i = 0; i < arr.length; i += 2) {
      const arr2: any = arr.slice(0, i + 1);

      arr1.push({
        breadcrumbName: _.get(this.menus, _.concat(arr2, ["menu_name"])),
        path: ""
        // path: _.get(this.menus, _.concat(arr2, ['menu_key']))
        // path: ''
      });

      arr3.push(_.get(this.menus, _.concat(arr2, ["menu_key"])));
    }
    this.menuSelectedKeys = arr3;
    window.localStorage.setItem("menuSelectedKeys", JSON.stringify(arr3));

    // console.log(this.menuSelectedKeys);
    // console.log(arr3);
    // 通过第一级
    this.getSubMenus(arr3[0]);

    this.collapsed = false;

    // console.log(arr1);
    this.$store.dispatch("setBreadcrumbs", arr1);
  }

  created() {
    // 菜单(这边会从后端获取)
    this.menus = [];

    // console.log(this.menus);
  }

  async mounted() {
    this.spinLoading = true;
    const { path } = this.$route;
    // console.log(path);

    // 得到用户信息
    this.userInfo = this.$store.state.user.userInfo;
    // console.log(this.userInfo)

    this.menus = this.$store.state.user.userMenus;
    // console.log(this.menus)
    // console.log(this.$store.state.user.userPerms)
    this.setCurrentPosition(path, "mounted");

    // this.intervalId = setInterval(() => {
    // this.newTimeRemind();
    // }, 60000);
    // this.computedHeight;

    this.spinLoading = false;

    this.isMounted = true;
  }

  get computedHeight() {
    if (!this.isMounted) return null;
    // @ts-ignore
    const obj1: any = this.$refs.mainContent;
    return obj1.$el.clientHeight;
  }

  beforeDestroy() {
    clearInterval(this.intervalId);
  }

  async newTimeRemind() {
    // 检查有新场馆注册
    const res = await this.$store.dispatch("stadium/getStadiumApplications", {});
    let stadiumlist = "";
    // console.log(res)
    if (res && res.Data && res.Data.data) {
      for (const obj of res.Data.data) {
        stadiumlist += obj.id;
      }
      if (this.oriStadiumData === "") {
        this.oriStadiumData = stadiumlist;
      } else if (this.oriStadiumData === stadiumlist) {
        // nothing to do
      } else {
        this.warnNotice(false);
        this.oriStadiumData = stadiumlist;
      }
    }

    // 检查有新的工单
    const res1 = await this.$store.dispatch("workorders/getWorkOrders", {});
    if (res1 && res1.Data && res1.Data.data) {
      let orderlist = "";
      for (const obj of res1.Data.data) {
        orderlist += obj.id;
      }
      if (this.oriMessageData === "") {
        this.oriMessageData = orderlist;
      } else if (this.oriMessageData === orderlist) {
        // nothing to do
      } else {
        this.warnNotice(true);
        this.oriMessageData = orderlist;
      }
    }
  }

  warnNotice(nodesc: any) {
    this.$notification.open({
      message: nodesc ? "您有新工单请及时查收" : "您有新场馆入驻申请",
      description: nodesc ? "您有新的工单，需要处理请及时查收" : "您有新场馆入驻申请处理请及时查收"
    });
    const promise: any = document.querySelector(nodesc ? "#order" : "#stadium");
    if (!this.isPlaying) {
      if (promise) {
        promise.play();
        this.isPlaying = true;
      }
    }
    const timeOut = setTimeout(() => {
      promise.pause();
      this.isPlaying = false;
    }, promise.duration * 1000);
  }

  clickMenu(params: any) {
    // params.stopPropagation();
    // window.localStorage.setItem("curmenu", params.key)
    // console.log(params)
    // this.menuSelectedKeys = params.keyPath
  }

  getSubMenus(key: string, from = "") {
    if (from !== "") {
      this.menuSelectedKeys = [key];
    }

    const subMenu: any = _.find(this.menus, (o) => o.menu_key === key);

    // console.log(subMenu);

    if (subMenu) {
      // this.menuLeft.marginLeft = "200px";
      this.subMenus = subMenu.children;
      this.subMenuSelectedKeys = [];
      // console.log(this.subMenus);
      const objs: any[] = this.subMenus;
      for (const obj of objs) {
        this.subMenuSelectedKeys.push(obj.menu_key);
      }
      if (from !== "") {
        this.$router.push({
          path: this.subMenus[0].menu_key
        });
      }
    } else {
      // this.menuLeft.marginLeft = 0;
    }
  }

  topMenuClick(params: any) {
    // console.log(params);
    this.getSubMenus(params.key, "topm");
  }
}
